<template>
  <div
    ref="main"
    class="app"
  >
    <div
      v-if="refreshToken"
      class="app__snack-bar"
    >
      <snack-bar />
    </div>
    <router-view v-slot="{ Component }">
      <transition
        name="fade"
        mode="out-in"
      >
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, onMounted, ref } from 'vue';
import SnackBar from './components/SnackBar.vue';
import { sendPostMessage } from './util/helper';
import { useStore } from 'vuex';
// import { URL_ASIAPAY } from './constant';
import { useRouter } from 'vue-router';


export default defineComponent({
  components: {
    SnackBar
  },
  setup(){
    const main = ref();
    const store = useStore();
    const router = useRouter();

    const refreshToken = computed(() => store.getters['refreshToken']);

    onMounted(() => {
      const observer = new ResizeObserver(entries => {
        if (entries?.length) {
          const height = entries[0].target.scrollHeight;
          const data = JSON.stringify({
            docHeight: height,
          });
          sendPostMessage('update_frame_height', 'success', data);
        }
      });

      observer.observe(main.value);

      window.addEventListener('message', (e) => {
        const { data } = e;
        if (data.action === 'update_url') {
          const pathname = data.data;
          router.push({ path: pathname });
        }
      });
    });

    return {
      main,
      refreshToken
    };
  }
});
</script>
<style lang="scss" scoped>
.app{
  // max-width: 1264px;
  // padding: 0 16px;
  // margin: 0 auto;
  position: relative;
  &__snack-bar{
    position: absolute;
    width: 100%;
    height: 100vh;
    z-index: 3;
  }
}
.tele2{
.app{
  padding: 0;
  max-width: 100%;
  width: 100%;
}
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
